import { render, staticRenderFns } from "./socialSecurityList.vue?vue&type=template&id=a4d3b4f4&scoped=true&"
import script from "./socialSecurityList.vue?vue&type=script&lang=js&"
export * from "./socialSecurityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d3b4f4",
  null
  
)

export default component.exports